import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import { getPalette, getPaletteAsRawColors } from 'owa-theme';
import type { IButtonStyles } from '@fluentui/react/lib/Button';

const generateDefaultButtonStyle = (colors: ColorScheme): IButtonStyles => {
    if (!colors) {
        return null;
    }

    const rootColor = getPaletteAsRawColors().white;
    const hoverColor = colors.calLighter;
    const pressedColor = colors.calLight;
    const focusBorderColor = getPaletteAsRawColors().neutralSecondary;
    const textColor = getOptimalTextColorString(
        rootColor,
        colors,
        getPaletteAsRawColors().neutralPrimary
    );
    const textActiveColor = getOptimalTextColorString(
        hoverColor,
        colors,
        getPaletteAsRawColors().neutralDark
    );

    let customStyle: IButtonStyles = {
        root: {
            backgroundColor: rootColor,
            color: textColor,
        },

        flexContainer: {
            justifyContent: 'center',
        },

        rootHovered: {
            backgroundColor: hoverColor,
            color: textActiveColor,
        },

        rootPressed: {
            backgroundColor: pressedColor,
            color: textActiveColor,
            border: 'none', // To avoid showing focused border on press
            boxShadow: 'none',
        },

        rootFocused: {
            border: 'solid 1px ' + getPalette().white, // Inner border
            boxShadow: '0 0 0 1px ' + focusBorderColor, // Outer border
            color: textActiveColor,
            backgroundColor: hoverColor,
        },

        rootDisabled: {
            backgroundColor: getPalette().neutralLight,
            color: getPalette().neutralTertiary,
        },
    };

    return customStyle;
};

export default generateDefaultButtonStyle;
